import { render, staticRenderFns } from "./RouteNamePolicy.vue?vue&type=template&id=6a173622&"
import script from "./RouteNamePolicy.vue?vue&type=script&lang=js&"
export * from "./RouteNamePolicy.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports